import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomModal,
  InputCnpj,
  InputPhone,
  InputText,
  SectionTitle,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useTransportadoraModal, { LOAD_MESSAGE } from './TransportadoraModalHook'

function TransportadoraModal({
  dispatch,
  selectedTp,
  visible,
  onModalClose,
  onModalSave,
  transportadora,
}) {
  const { state, localDispatch } = useTransportadoraModal()

  useEffect(() => {
    if (visible) localDispatch.onInit(transportadora)
  }, [visible])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.NEW_TRANSPORTADORA:
        dispatch(showLoadingBox('Aguarde...', 'Salvando nova transportadora'))
        localDispatch.saveTransportadora(state.transportadora, selectedTp)
        break

      case LOAD_MESSAGE.UPDATE_TRANSPORTADORA:
        dispatch(showLoadingBox('Aguarde...', 'Atualizando dados da transportadora'))
        localDispatch.updateTransportadora(state.transportadora)
        break

      case LOAD_MESSAGE.LOADING_UFS:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchUFs(state.transportadora.uf_id)
        break

      case LOAD_MESSAGE.LOADING_CITIES:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchCities(state.selectedUf.id, state.transportadora)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        onModalSave(state.updatedTransportadora)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      isVisible={visible}
      onClose={() => {
        localDispatch.onClose()
        onModalClose()
      }}
      header={state.transportadora.id ? 'Editando Transportadora' : 'Nova Transportadora'}
      width={600}
    >
      <div className="p-grid">
        <div className="p-col-6">
          <InputText
            label="Nome :*"
            marginTop={10}
            value={state.transportadora.nome}
            onChange={value => localDispatch.onInputChange('nome', value.toUpperCase())}
          />
        </div>
        <div className="p-col-6">
          <InputCnpj
            label="CNPJ :*"
            marginTop={10}
            value={state.transportadora.cnpj}
            onChange={({ value }) => localDispatch.onInputChange('cnpj', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            optionLabel="name"
            options={state.ufs}
            value={state.selectedUf}
            label="Estado :*"
            filter={true}
            onChange={value => localDispatch.onEstadoChange('uf_id', value)}
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            disabled={state.selectedUf === 0 ? true : false}
            optionLabel="name"
            options={state.cities}
            value={state.selectedCity}
            label="Cidade :*"
            filter={true}
            onChange={value => localDispatch.onCityChange('city_id', value)}
          />
        </div>
        <div className="p-col-6">
          <InputPhone
            label="Telefone :"
            marginTop={10}
            value={state.transportadora.telefone}
            onChange={value => localDispatch.onInputChange('telefone', value)}
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 42 }}>
          <CustomCheckbox
            onChange={value => localDispatch.onInputChange('actived', value)}
            checked={state.transportadora.actived}
          >
            Ativo
          </CustomCheckbox>
        </div>

        <div className="p-col-12" style={{ marginTop: 10 }}>
          <SectionTitle title="Dados para MDFe (Opcional)" />
        </div>
        <div className="p-col-6">
          <InputText
            label="RNTRC :"
            marginTop={10}
            value={state.transportadora.rntrc || ''}
            placeholder="8 dígitos"
            onChange={value =>
              localDispatch.onInputChange('rntrc', value.replace(/\D/g, '').slice(0, 8))
            }
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Inscrição Estadual :"
            marginTop={10}
            value={state.transportadora.inscricao_estadual || ''}
            onChange={value =>
              localDispatch.onInputChange(
                'inscricao_estadual',
                value
                  .toUpperCase()
                  .replace(/[^0-9A-Z]/g, '')
                  .slice(0, 14),
              )
            }
          />
        </div>

        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClick(state.transportadora)}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}
const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(TransportadoraModal)
